// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"guidelines_wrapper__OhyXf","box":"guidelines_box__ZgHm_","icon":"guidelines_icon__v_i9j","text":"guidelines_text__tpa6L","contact":"guidelines_contact__XlYmm"};